<template>
  <div class="text-center">
    <v-navigation-drawer
      app
      v-model="drawer"
      absolute
      bottom
      right
      style="box-shadow: 0 0 0 0, 0 0 0 0 , 0 0 0 0;"
      temporary
    >
      <v-card elevation="0" color="transparent">
        <v-card-text class="text-uppercase mt-6">
          Comprovativo
        </v-card-text>

        <v-card-text class="text-left text-uppercase m-size-font-12">
          <b>Destino</b>: {{ item.entityName }}
        </v-card-text>
        <v-card-text class="text-left text-uppercase m-size-font-12 mt-n6">
          <b>Data da operação</b>: {{ formatData(item.dateTransaction) }}
        </v-card-text>
        <v-card-text class="text-left text-uppercase m-size-font-12 mt-n6">
          <b>Produto</b>: {{ item.productName }}
        </v-card-text>
        <v-card-text class="text-left text-uppercase m-size-font-12 mt-n6">
          <b>Descrição da Compra</b>: {{ item.transactionDescription }}
        </v-card-text>
        <v-card-text class="text-uppercase m-size-font-12">
          <b><v-icon color="green">mdi-download</v-icon></b>
        </v-card-text>
        <v-card-text class="text-uppercase m-size-font-12 mt-n6">
          <v-btn
            outlined
            color="green"
            @click="printReceipt(item.transactionUUID)"
            >Descarregar</v-btn
          >
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
  </div>
</template>

<script>
import eventBus from "@/main";

export default {
  name: "OpenModalTransactionClient",
  data: () => ({
    dialog: false,
    drawer: false,
    item: Object
  }),
  methods: {
    formatData(convertData) {
      let format = new Date(convertData);
      return format.toISOString().split("T")[0];
    },
    printReceipt(ref) {
      this.$store.dispatch("printReceipt", ref);
    }
  },
  created() {
    const self = this;
    eventBus.$on("openModalTransactionClient", function(value) {
      self.dialog = value.dialog;
      self.drawer = value.drawer;
      self.item = value.operation;
    });
  }
};
</script>

<style scoped></style>
